import { RemoteGetTeamReportList } from 'data/usecases';
import { GetTeamReportList } from 'domain/usecases';
import { makeApiUrlTeamReport } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeTeamReportList = (): GetTeamReportList =>
  new RemoteGetTeamReportList(makeApiUrlTeamReport(), makeAxiosHttpClient());
